
import { RefCodeEntityDecorator } from './ref-code.decorator';
import { RefCode, RefCodeKey } from './ref-code.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class RefCodeTypeInfoBase implements CrudTypeInfo<RefCode, RefCodeKey> {
  name = 'Ref Code';
  entityDecorator = new RefCodeEntityDecorator();
  
  createAuthorities = ['WRITE_REF_CODE'];
  editAuthorities = ['WRITE_REF_CODE'];
  deleteAuthorities = ['WRITE_REF_CODE'];
  viewAuthorities = ['READ_REF_CODE'];
  
  searchRouteBase = ['/refcode/search'];
  createRouteBase = ['/refcode/create'];
  editRouteBase = ['/refcode/edit'];
  viewRouteBase = ['/refcode/view'];
  
  description(item: RefCode): string {
    return '' +  item.code +  ' - ' +  item.domain;
  }
}



